import * as types from "./types";
import JigsawAPI from "../../services/jigsaw";
import { actions as booksActions } from "../books";
import * as selectors from "./selectors";

const searchCountsBegin = data => ({
  ...data,
  type: types.COUNTS_SEARCH_REQUEST
});

const searchCountsSuccess = data => ({
  ...data,
  type: types.COUNTS_SEARCH_SUCCESS
});

export const countsSearch = (query, page = 1) => async dispatch => {
  dispatch(searchCountsBegin({ query, page }));
  const response = await JigsawAPI.Search.counts(query, {
    order: "recent",
    page
  });
  dispatch(
    searchCountsSuccess({
      ...response,
      query
    })
  );

  if (response.page < response.pages && response.results.length === 0) {
    return dispatch(loadNextPageOfCounts(query));
  }

  const isbns = Object.keys(response.results).map(
    k => response.results[k].isbn
  );

  dispatch(booksActions.getBookInfo(isbns));
};

export const loadNextPageOfCounts = q => async (dispatch, getState) => {
  const state = getState();
  if (!selectors.isCountsLoading(state, q)) {
    const { pages, totalPages } = selectors.getCounts(state, q);
    const loadedPages = Object.keys(pages).length;
    if (loadedPages < totalPages) {
      return dispatch(countsSearch(q, loadedPages + 1));
    }
  }
};

const searchBookContentRequest = (isbn, query) => ({
  type: types.SEARCH_BOOK_CONTENT_REQUEST,
  isbn,
  query
});

const searchBookContentSuccess = (isbn, query, results) => ({
  type: types.SEARCH_BOOK_CONTENT_SUCCESS,
  isbn,
  query,
  results
});

const searchBookContentFailure = (isbn, query) => ({
  type: types.SEARCH_BOOK_CONTENT_FAILURE,
  isbn,
  query
});

const searchMetadataRequest = query => ({
  type: types.SEARCH_BOOK_METADATA_REQUEST,
  query
});

const searchMetadataSuccess = (results, query, source) => ({
  type: types.SEARCH_BOOK_METADATA_SUCCESS,
  results,
  query,
  source
});

const searchMetadataComplete = query => ({
  type: types.SEARCH_BOOK_METADATA_COMPLETE,
  query
});

const searchMetadataFailure = error => ({
  type: types.SEARCH_BOOK_METADATA_FAILURE,
  error
});

export const searchBookContent = (isbn, query) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const lastSearchTerm = selectors.getCurrentSearchTermForIsbn(state, isbn);
  if (lastSearchTerm !== query) {
    dispatch(searchBookContentRequest(isbn, query));
    return JigsawAPI.Search.book(isbn, query)
      .then(results => dispatch(searchBookContentSuccess(isbn, query, results)))
      .catch(() => dispatch(searchBookContentFailure(isbn, query)));
  }
};

export const searchMetadata = query => async dispatch => {
  dispatch(searchMetadataRequest(query));
  return JigsawAPI.Search.metadata(query)
    .then(results => {
      dispatch(searchMetadataSuccess(results, query, types.LICENSE_SOURCE));
      dispatch(searchMetadataComplete(query));
    })
    .catch(err => dispatch(searchMetadataFailure(err)));
};
